function useDefaultExport(libraryModule) {
  return libraryModule.default || libraryModule;
}

export function loadHtml2PDF() {
  // PDF generation is only needed after a user requests an export.
  return import(/* webpackChunkName: "report-pdf" */ '../lib/html2pdf/html2pdf.bundle.min.js')
    .then(useDefaultExport);
}

export function loadClassicEditor() {
  // The editor is only needed when an editable wall post is shown.
  return import(/* webpackChunkName: "rich-text-editor" */ '@ckeditor/ckeditor5-build-classic')
    .then(useDefaultExport);
}

export function loadVideoPlayer() {
  // The player and its styles are only needed on the Help Video Library route.
  return Promise.all([
    import(/* webpackChunkName: "video-player" */ 'video.js/dist/video.js'),
    import(/* webpackChunkName: "video-player" */ 'video.js/dist/video-js.css')
  ]).then(function (videoPlayerModules) {
    return useDefaultExport(videoPlayerModules[0]);
  });
}
